var map = {
	"./ion-accordion_2.entry.js": [
		1264,
		2076,
		1264
	],
	"./ion-action-sheet.entry.js": [
		3723,
		2076,
		3723
	],
	"./ion-alert.entry.js": [
		2401,
		2076,
		2401
	],
	"./ion-app_8.entry.js": [
		3999,
		2076,
		2433
	],
	"./ion-avatar_3.entry.js": [
		9368,
		9368
	],
	"./ion-back-button.entry.js": [
		737,
		2076,
		737
	],
	"./ion-backdrop.entry.js": [
		6265,
		6265
	],
	"./ion-breadcrumb_2.entry.js": [
		9007,
		2076,
		9007
	],
	"./ion-button_2.entry.js": [
		5762,
		5762
	],
	"./ion-card_5.entry.js": [
		4433,
		4433
	],
	"./ion-checkbox.entry.js": [
		4650,
		4650
	],
	"./ion-chip.entry.js": [
		4745,
		4745
	],
	"./ion-col_3.entry.js": [
		8131,
		8131
	],
	"./ion-datetime-button.entry.js": [
		6975,
		7384,
		6975
	],
	"./ion-datetime_3.entry.js": [
		3636,
		7384,
		2076,
		3636
	],
	"./ion-fab_3.entry.js": [
		6964,
		2076,
		6964
	],
	"./ion-img.entry.js": [
		1156,
		1156
	],
	"./ion-infinite-scroll_2.entry.js": [
		1560,
		2076,
		4706
	],
	"./ion-input.entry.js": [
		7391,
		2076,
		7391
	],
	"./ion-item-option_3.entry.js": [
		2178,
		2076,
		4796
	],
	"./ion-item_8.entry.js": [
		4199,
		2076,
		4199
	],
	"./ion-loading.entry.js": [
		6380,
		3999
	],
	"./ion-menu_3.entry.js": [
		5026,
		2076,
		5026
	],
	"./ion-modal.entry.js": [
		8878,
		2076,
		8878
	],
	"./ion-nav_2.entry.js": [
		3259,
		2076,
		3259
	],
	"./ion-picker-column-internal.entry.js": [
		1492,
		2076,
		1492
	],
	"./ion-picker-internal.entry.js": [
		5383,
		5383
	],
	"./ion-popover.entry.js": [
		7190,
		2076,
		7190
	],
	"./ion-progress-bar.entry.js": [
		3304,
		3304
	],
	"./ion-radio_2.entry.js": [
		6409,
		6409
	],
	"./ion-range.entry.js": [
		7546,
		2076,
		7546
	],
	"./ion-refresher_2.entry.js": [
		4810,
		2076,
		2132
	],
	"./ion-reorder_2.entry.js": [
		9430,
		2076,
		7063
	],
	"./ion-ripple-effect.entry.js": [
		3771,
		3771
	],
	"./ion-route_4.entry.js": [
		7422,
		5041
	],
	"./ion-searchbar.entry.js": [
		5998,
		2076,
		5998
	],
	"./ion-segment_2.entry.js": [
		9075,
		2076,
		9075
	],
	"./ion-select_3.entry.js": [
		7053,
		7053
	],
	"./ion-slide_2.entry.js": [
		1351,
		1351
	],
	"./ion-spinner.entry.js": [
		9950,
		2076,
		9950
	],
	"./ion-split-pane.entry.js": [
		390,
		390
	],
	"./ion-tab-bar_2.entry.js": [
		7641,
		2076,
		7641
	],
	"./ion-tab_2.entry.js": [
		5529,
		2076,
		5529
	],
	"./ion-text.entry.js": [
		4036,
		4036
	],
	"./ion-textarea.entry.js": [
		6673,
		6673
	],
	"./ion-toast.entry.js": [
		8504,
		8504
	],
	"./ion-toggle.entry.js": [
		891,
		2076,
		891
	],
	"./ion-virtual-scroll.entry.js": [
		2072,
		2072
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8546;
module.exports = webpackAsyncContext;